import { NgTemplateOutlet } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import {
  Component,
  input
} from '@angular/core';
import { SymbolType } from '../../domain/symbol.domain';
import { AutoSuggestSymbol } from '../../domain/symbol-lookup.domain';
import { IconFlagComponent } from '../../components/icon/icon-flag.component';
import { SymbolLookupHighlightPipe } from './symbol-lookup.highlight.pipe';

@Component({
  selector: 'td-wb-symbol-lookup-item-label',
  templateUrl: 'symbol-lookup-item-label.component.html',
  styleUrls: ['symbol-lookup-item-label.component.scss'],
  imports: [
    TranslateDirective,
    SymbolLookupHighlightPipe,
    IconFlagComponent,
    NgTemplateOutlet
  ]
})
export class SymbolLookupItemLabelComponent {
  readonly item = input<AutoSuggestSymbol>(undefined);
  readonly highlight = input<string>(undefined);
  readonly compact = input<boolean>(false);

  isMutualFund(): boolean {
    const item = this.item();
    return item !== undefined && item.symbolType === SymbolType.MUTUALFUND;
  }
}
